// extracted by mini-css-extract-plugin
export default {"formHeading":"lM-z","form":"mM-z","submitBtn":"nM-z","disabled":"oM-z","input":"pM-z","error":"qM-z","submitMsg":"rM-z","signIn":"sM-z"};